"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useIdentity } from "@/hooks/useIdentity";
import { useParams } from "next/navigation";
import type { ActivityLogParams } from "@/components/profile-activity/ProfileActivityLogs";
import UserPageSetUpProfileWrapper from "../utils/set-up-profile/UserPageSetUpProfileWrapper";
import UserPageRep from "./UserPageRep";
export default function UserPageRepWrapper(t0) {
  const $ = _c(11);
  const {
    profile: initialProfile,
    initialActivityLogParams
  } = t0;
  const params = useParams();
  let t1;
  if ($[0] !== params?.user) {
    t1 = (params?.user as string)?.toLowerCase();
    $[0] = params?.user;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const user = t1;
  let t2;
  if ($[2] !== initialProfile || $[3] !== user) {
    t2 = {
      handleOrWallet: user,
      initialProfile
    };
    $[2] = initialProfile;
    $[3] = user;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    profile
  } = useIdentity(t2);
  const t3 = profile ?? initialProfile;
  const t4 = profile ?? initialProfile;
  let t5;
  if ($[5] !== initialActivityLogParams || $[6] !== t4) {
    t5 = <UserPageRep profile={t4} initialActivityLogParams={initialActivityLogParams} />;
    $[5] = initialActivityLogParams;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <UserPageSetUpProfileWrapper profile={t3}>{t5}</UserPageSetUpProfileWrapper>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}